<h1 mat-dialog-title>{{title}}</h1>
<p [innerHTML]="message | safeHTML"></p>
<!--<div mat-dialog-content>
  
</div>-->
<div mat-dialog-actions>
  <button mat-raised-button *ngFor="let opt of options" [color]="opt.Color" (click)="OptionHandler(opt.Response)">{{opt.DisplayText}}</button>
</div>
